import { render, staticRenderFns } from "./CopyrightPracticeNav.vue?vue&type=template&id=66507227&scoped=true&"
import script from "./CopyrightPracticeNav.vue?vue&type=script&lang=js&"
export * from "./CopyrightPracticeNav.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightPracticeNav.vue?vue&type=style&index=0&id=66507227&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66507227",
  null
  
)

export default component.exports